import { useApi } from '../context/ApiProvider';
import type {
  PublicationAuthorOption,
  PublicationListResponse,
  PublicationRecord,
  UpsertPublicationPayload,
} from '../features/publications/types';

export const PublicationsApi = (api: ReturnType<typeof useApi>) => ({
  listPublications: () =>
    api.get<{ publications: PublicationRecord[] }>('/publications').then((response) => response.data.publications),

  getPublicationBySlug: (slug: string) =>
    api.get<{ publication: PublicationRecord | null }>(`/publications/${slug}`).then((response) => response.data.publication),

  listAdminPublications: (params: {
    q?: string;
    status?: string;
    category?: string;
    subcategory?: string;
    page?: number;
  }) => api.get<PublicationListResponse>('/admin/publications', { params }).then((response) => response.data),

  listPublicationAuthors: () =>
    api
      .get<{ authors: PublicationAuthorOption[] }>('/admin/publications/authors')
      .then((response) => response.data.authors),

  getAdminPublication: (publicationId: string) =>
    api.get<PublicationRecord>(`/admin/publications/${publicationId}`).then((response) => response.data),

  createPublication: (payload: UpsertPublicationPayload) =>
    api.post<PublicationRecord>('/admin/publications', payload).then((response) => response.data),

  updatePublication: (publicationId: string, payload: UpsertPublicationPayload) =>
    api.patch<PublicationRecord>(`/admin/publications/${publicationId}`, payload).then((response) => response.data),

  deletePublication: (publicationId: string) =>
    api.delete<{ ok: true; id: string }>(`/admin/publications/${publicationId}`).then((response) => response.data),
});

export const usePublicationsApi = () => PublicationsApi(useApi());
